<template>
  <RCard class="subscriptions">
    <AgGrid ref="agGrid" :options="gridOptions" :api-request="infiniteScrollRequest">
      <template #header>
        <div class="text-subtitle-1 text-secondary-2 q-ml-sm q-mt-sm">Subscriptions</div>
      </template>
    </AgGrid>
  </RCard>
</template>

<script>
import * as apiTo from '@/modular-api'
import { dateSorter, periodRenderer } from '@lib/generic.utils'
import { agPriceCol } from '@/ag-grid/ag-columns'
import { notAnyPriceCheck } from '@/ag-grid/utils/notAnyValue'
// Components
import AgGrid from '@/ag-grid/AgGrid'

export default {
  components: {
    AgGrid
  },

  props: {
    id: [Number, String] // from route
  },

  data: () => ({
    totalRows: null
  }),

  computed: {
    gridOptions() {
      return {
        columnDefs: [
          {
            headerName: 'Name',
            field: 'name',
            tooltipField: 'name',
            cellRendererFramework: 'LinkRenderer',
            cellRendererParams: params => {
              return {
                route: `/subscriptions/${params.data.subscription.id}`
              }
            }
          },

          {
            headerName: 'Period',
            field: 'start_date',
            comparator: dateSorter,
            cellRenderer: params => periodRenderer(params.data),
            tooltipValueGetter: params => periodRenderer(params.data)
          },

          agPriceCol('Final Price', 'price'),

          agPriceCol('Price in Local Currency', 'normalized_price', {
            cellRenderer: params => notAnyPriceCheck(params, 'normalized_currency'),
            tooltipValueGetter: params => notAnyPriceCheck(params, 'normalized_currency', true)
          })
        ],

        rowModelType: 'serverSide',
        serverSideStoreType: 'partial',
        cacheBlockSize: 40
      }
    }
  },

  methods: {
    infiniteScrollRequest(request) {
      return apiTo.GET_PAGINATED_VENDOR_SUBSCRIPTIONS(this.id, request)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

.subscriptions {
  @include table-with-no-filters;
}
</style>
